import React, { useState } from 'react'
import WorkOrderDescription from '@components/workOrder/WorkOrderDescription'
import WorkOrderDocuments from '@components/workOrder/WorkOrderDocuments'
import WorkOrderInformation from '@components/workOrder/WorkOrderInformation'
import WorkOrderTaskButtons from '@components/workOrder/WorkOrderTaskButtons'
import ScrollContainer from '@components/ScrollContainer'
import Show from '@components/Show'
import QueryError from '@components/QueryError'
import PopupWebview from '@components/PopupWebview'
import FAB from '@components/FAB'
import { QuestionAnswerIcon } from '@components/Icons'
import useQuery from '@hooks/useQuery'
import GET_WORK_ORDER_BY_NUMBER from '@lib/queries/getWorkOrderByNumber'
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native'
import MainLayout from '@layouts/MainLayout'
import { colors } from '@lib/colors'
import { i18n } from '@lib/i18n'
import useNavigation from '@hooks/useNavigation'
import { useCurrentUser } from '@context/CurrentUserContext'
import { encode as btoa } from 'base-64'

const COPY = i18n.en.WORK_ORDERS.VIEW

interface WorkOrdersData {
  workOrders: [WorkOrder]
}

export default function ({ route }: any) {
  const navigation = useNavigation()
  const { currentUser } = useCurrentUser()
  const { workOrderNumber } = route.params
  const { data, error, loading } = useQuery<WorkOrdersData>(GET_WORK_ORDER_BY_NUMBER, { workOrderNumber })
  const workOrder = data?.workOrders[0]
  const [chatVisible, setChatVisible] = useState<boolean>(false)
  const toggleChat = () => setChatVisible(!chatVisible)

  const goToTask = (taskId: string) => {
    navigation.navigate('task', { workOrderNumber, taskId })
  }

  const chatUrl = () => {
    const hash = btoa(JSON.stringify({
      id: currentUser.id,
      name: `${currentUser.firstName} ${currentUser.lastName}`,
      email: currentUser.email,
    }))

    return `https://dev.drxxhu5ymx1wf.amplifyapp.com?id=${workOrder?.id || ''}&user=${hash}`
  }

  return (
    <>
      <MainLayout>
        <ScrollContainer>
          <View style={ styles.header }>
            <Text style={ styles.headerTitle }>{ COPY.WORK_ORDER }</Text>
            <Text style={ styles.headerNumber }>#{ workOrderNumber }</Text>
          </View>

          <Show when={loading}>
            <ActivityIndicator />
          </Show>

          <Show when={workOrder}>
            <WorkOrderDescription description={workOrder?.description} />
            <WorkOrderInformation
              status={workOrder?.status.name}
              endDate={workOrder?.endDate}
            />
            <WorkOrderTaskButtons
              tasks={workOrder?.tasks || []}
              goToTask={ goToTask }
            />
            <WorkOrderDocuments documents={dummyDocuments} />
          </Show>

          <Show when={error}>
            <QueryError text={ COPY.LOAD_FAILED } />
          </Show>
        </ScrollContainer>
      </MainLayout>
      <FAB
        icon={<QuestionAnswerIcon color={colors.white} />}
        onPress={toggleChat}
      />
      <Show when={workOrder?.id}>
        <PopupWebview
          dismiss={toggleChat}
          source={chatUrl()}
          visible={chatVisible}
        />
      </Show>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingBottom: 50,
  },
  header: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 20,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.gray[800],
    textAlign: 'left',
  },
  headerNumber: {
    fontSize: 22,
    fontWeight: '400',
    color: colors.gray[500],
    textAlign: 'right',
  },
})

const dummyDocuments = [
  { name: 'COI' },
  { name: 'Building Access Instruction/ Details' },
  { name: 'Floor Plans' },
  { name: 'Additional Documents' },
  { name: 'Additional Photos' },
]
